import { IPagination } from 'app/types/common';

export interface IPayout {
  fullName: string;
  email: string;
  mobile: string;
  createdAt: Date;
  updatedAt: Date;
  status: null;
  teamName: string;
  team: {
    id: string;
  };
  consumer: {
    id: string;
  };
  financialStatus: string;
  pendingTeamPaymentCollectionsTotalCount: number;
  paidTeamPaymentCollectionsTotalCount: number;
  overdueTeamPaymentCollectionsTotalCount: number;
  pendingTeamPaymentCollectionsTotalAmount: number;
  paidTeamPaymentCollectionsTotalAmount: number;
  overdueTeamPaymentCollectionsTotalAmount: number;
}
export interface IPayoutsState {
  readonly payoutsById?: any;
  readonly payoutIds?: string[];
  readonly hasSaved?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly showAddPayout?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationPayoutIds?: string[];
  readonly currentPayoutId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IPayoutsSelector extends IPayoutsState {
  readonly currentPayout?: any;
  readonly currentFormPayout?: any;
  readonly getPayoutsFilteredByTagInSelectFormat?: any;
  readonly payoutsByIdInSelectFormat?: any;
}

export enum PayoutsActionTypes {
  GET_ALL_PAYOUTS_REQUESTED = 'redux-app/payouts/GET_ALL_PAYOUTS_REQUESTED',
  GET_ALL_PAYOUTS_PENDING = 'redux-app/payouts/GET_ALL_PAYOUTS_PENDING',
  GET_ALL_PAYOUTS_SUCCESS = 'redux-app/payouts/GET_ALL_PAYOUTS_SUCCESS',
  GET_ALL_PAYOUTS_FAIL = 'redux-app/payouts/GET_ALL_PAYOUTS_FAIL',
  GET_PAYOUT_REQUESTED = 'redux-app/payouts/GET_PAYOUT_REQUESTED',
  GET_PAYOUT_PENDING = 'redux-app/payouts/GET_PAYOUT_PENDING',
  GET_PAYOUT_SUCCESS = 'redux-app/payouts/GET_PAYOUT_SUCCESS',
  GET_PAYOUT_FAIL = 'redux-app/payouts/GET_PAYOUT_FAIL',
  UPDATE_PAYOUT_REQUESTED = 'redux-app/payouts/UPDATE_PAYOUT_REQUESTED',
  UPDATE_PAYOUT_PENDING = 'redux-app/payouts/UPDATE_PAYOUT_PENDING',
  UPDATE_PAYOUT_SUCCESS = 'redux-app/payouts/UPDATE_PAYOUT_SUCCESS',
  UPDATE_PAYOUT_FAIL = 'redux-app/payouts/UPDATE_PAYOUT_FAIL',
  CREATE_PAYOUT_REQUESTED = 'redux-app/payouts/CREATE_PAYOUT_REQUESTED',
  CREATE_PAYOUT_PENDING = 'redux-app/payouts/CREATE_PAYOUT_PENDING',
  CREATE_PAYOUT_SUCCESS = 'redux-app/payouts/CREATE_PAYOUT_SUCCESS',
  CREATE_PAYOUT_FAIL = 'redux-app/payouts/CREATE_PAYOUT_FAIL',
  DELETE_PAYOUT_REQUESTED = 'redux-app/payouts/DELETE_PAYOUT_REQUESTED',
  DELETE_PAYOUT_PENDING = 'redux-app/payouts/DELETE_PAYOUT_PENDING',
  DELETE_PAYOUT_SUCCESS = 'redux-app/payouts/DELETE_PAYOUT_SUCCESS',
  DELETE_PAYOUT_FAIL = 'redux-app/payouts/DELETE_PAYOUT_FAIL',
  SELECT_PAYOUT_REQUESTED = 'redux-app/payouts/SELECT_PAYOUT_REQUESTED',
  CLEAR_PAYOUTS = 'redux-app/payouts/CLEAR_PAYOUTS',
}

export default null;
